<template>

    <div class="trax-struct-map trax-struct-flat" v-show="loaded">
        <div :id="id+'-struct'" class="trax-struct-body">
            <div class="trax-block trax-level-1" v-for="section in sections" :key="section.id" :data-id="section.id"
                 v-if="hasUnits(section)">

                <h3 v-if="sections.length>1">{{ section.name }}</h3>

                <div class="clearfix"></div>

                <div :id="id+'-struct-'+section.id" class="trax-block-body" :data-id="section.id">

                    <div class="card" v-for="learning_unit in section.learning_units" :key="learning_unit.id" v-if="programUnit(learning_unit) && missingSignature(learning_unit)">
                        <div class="card-body">

                            <enac-atpl-dashboard-phase-map-item
                                :id="id" :bus="bus" :item="learning_unit" :states="states" :individual="true">
                            </enac-atpl-dashboard-phase-map-item>

                            <div class="row">
                                <div class="col-xl-7 pb-0 trax-name">
                                    <h4>{{ learning_unit.name }}</h4>
                                </div>
                                <div class="col-xl-5" v-html="itemSignatures(learning_unit)"></div>
                            </div>
                        </div>
                    </div>

                    <div class="trax-btn-square trax-icon" v-if="hasGroupUnits(section)">
                        + <i class="material-icons">people_outline</i>
                    </div>

                    <div class="card" v-for="learning_unit in section.learning_units" :key="learning_unit.id" v-if="groupUnit(learning_unit) && missingSignature(learning_unit)">
                        <div class="card-body">

                            <enac-atpl-dashboard-phase-map-item
                                :id="id" :bus="bus" :item="learning_unit" :states="states" :individual="true">
                            </enac-atpl-dashboard-phase-map-item>

                            <div class="row">
                                <div class="col-xl-7 pb-0 trax-name">
                                    <h4>{{ learning_unit.name }}</h4>
                                </div>
                                <div class="col-xl-5" v-html="itemSignatures(learning_unit)"></div>
                            </div>
                        </div>
                    </div>

                    <div class="trax-btn-square trax-icon" v-if="hasUserUnits(section)">
                        + <i class="material-icons">person_outline</i>
                    </div>

                    <div class="card" v-for="learning_unit in section.learning_units" :key="learning_unit.id" v-if="userUnit(learning_unit) && missingSignature(learning_unit)">
                        <div class="card-body">

                            <enac-atpl-dashboard-phase-map-item
                                :id="id" :bus="bus" :item="learning_unit" :states="states" :individual="true">
                            </enac-atpl-dashboard-phase-map-item>

                            <div class="row">
                                <div class="col-xl-7 pb-0 trax-name">
                                    <h4>{{ learning_unit.name }}</h4>
                                </div>
                                <div class="col-xl-5" v-html="itemSignatures(learning_unit)"></div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
    export default {

        props: {
            id: null,
            bus: null
        },

        data: function() {
            return {
                lang: lang,
                loaded: false,
                user: user,
                learner: data.learner,
                registration: data.registration,
                url_base: app_url+'polaris/ui/atpl-dashboard/registration/'+data.registration.id+'/',
                endpoint: app_url+'polaris/api/front/dashboard/registrations/'+data.registration.id+'/phases/'+data.phase.id+'/learners/'+data.learner.id+'/with-program',
                sections: [],
                states : {}
            }
        },

        created: function() {
            this.getDataWithStates();
        },

        methods: {

            programUnit(learning_unit) {
                return !learning_unit.registration_id;
            },

            groupUnit(learning_unit) {
                return learning_unit.registration_id && !learning_unit.user_id;
            },

            userUnit(learning_unit) {
                return learning_unit.user_id;
            },

            hasUnits(section) {
                return section.learning_units && (this.hasProgramUnits(section) || this.hasGroupUnits(section) || this.hasUserUnits(section));
            },

            hasProgramUnits(section) {
                for (var index in section.learning_units) {
                    var learning_unit = section.learning_units[index];
                    if (this.programUnit(learning_unit)) {
                        if (this.missingSignature(learning_unit)) return true;
                    }
                }
                return false;
            },

            hasGroupUnits(section) {
                for (var index in section.learning_units) {
                    var learning_unit = section.learning_units[index];
                    if (this.groupUnit(learning_unit)) {
                        if (this.missingSignature(learning_unit)) return true;
                    }
                }
                return false;
            },

            hasUserUnits(section) {
                for (var index in section.learning_units) {
                    var learning_unit = section.learning_units[index];
                    if (this.userUnit(learning_unit)) {
                        if (this.missingSignature(learning_unit)) return true;
                    }
                }
                return false;
            },

            getDataWithStates() {
                axios.get(this.endpoint)
                    .then(response => {
                        this.states = Array.isArray(response.data.data) ? {} : response.data.data
                        this.sections = response.data.included.sections;
                        this.loaded = true;
                    })
                    .catch(error => {
                    });
            },

            itemSignatures(learning_unit) {
                if (!this.states[learning_unit.id]) return '';
                var state = this.states[learning_unit.id];
                var html = '';

                // Author.
                if (state.validation) html += this.validatedHtml(state.validation);
                else if (state.author && state.author.user_uuid) {
                    html += this.unvalidatedHtml(state.author);
                    html += this.itemAction(learning_unit);
                    return html;
                }

                // Learner.
                if (state.learner_validation) html += this.validatedHtml(state.learner_validation, true);
                else html += this.unvalidatedHtml(this.learner, true);

                // Third.
                if (state.third_validation) html += this.validatedHtml(state.third_validation, true);
                else if (state.additional_signatory && state.additional_signatory.user_uuid) {
                    html += this.unvalidatedHtml(state.additional_signatory, true);
                } else if (learning_unit.type == 'enac-atpl-level-report') {
                    html += this.unvalidatedThirdHtml();
                } 

                html += this.itemAction(learning_unit);
                return html;
            },

            missingSignature(learning_unit) {
                if (!this.states[learning_unit.id]) return false;
                var state = this.states[learning_unit.id];

                // Status.
                if (!state.color_status) return false;

                // Author.
                if (!state.validation && state.author && state.author.user_uuid) return true;

                // Learner.
                if (!state.learner_validation) return true;

                // Third.
                if (!state.third_validation) {
                    if (state.additional_signatory && state.additional_signatory.user_uuid) {
                        return true;
                    } else if (learning_unit.type == 'enac-atpl-level-report') {
                        return true;
                    }
                } 
                return false;
            },

            validatedHtml(validation, newLine) {
                var html = newLine ? '<br>' : '';
                html += '<small>';
                html += '   <i class="material-icons" style="position:relative !important;top:3px !important;">done</i> ';
                html += validation.user_name;
                html += '</small>';
                return html;
            },

            unvalidatedHtml(user, newLine) {
                var userName = user.user_name ? user.user_name : user.lastname + ' ' + user.firstname;
                var html = newLine ? '<br>' : '';
                html += '<small class="text-danger">';
                html += '   <i class="material-icons text-danger" style="position:relative !important;top:3px !important;">error_outline</i> ';
                html += userName;
                html += '</small>';
                return html;
            },

            unvalidatedThirdHtml() {
                var userName = lang.polaris.dashboard.additional_signatory;
                var html = '<br>';
                html += '<small class="text-danger">';
                html += '   <i class="material-icons text-danger" style="position:relative !important;top:3px !important;">error_outline</i> ';
                html += userName;
                html += '</small>';
                return html;
            },

            itemAction(learning_unit) {
                if (!this.states[learning_unit.id]) return '';
                if (this.registration.status == 'archived') return '';

                var state = this.states[learning_unit.id];
                var html = '<br>';
                var link = false;

                // Nobody validates or countersigns their own sheet: only the learner
                // signature below is offered on one's own training.
                var notMyOwnSheet = this.learner.uuid != this.user.uuid;

                // Author should sign.
                if (!state.validation && state.author && state.author.user_uuid && notMyOwnSheet
                    && state.author.user_uuid == this.user.uuid) {
                    link = 'edit';
                }

                // Learner should sign.
                if (state.validation && !state.learner_validation && this.learner.uuid == this.user.uuid) {
                    link = 'view';
                }

                // Third signatory should sign.
                if (state.validation && !state.third_validation && state.additional_signatory && notMyOwnSheet
                    && state.additional_signatory.user_uuid && state.additional_signatory.user_uuid == this.user.uuid) {
                    link = 'view';
                }

                // LR third signatory should sign.
                if (state.validation && !state.third_validation && learning_unit.type == 'enac-atpl-level-report' 
                    && notMyOwnSheet
                    && (this.user.user_function == 'training' || this.user.user_function == 'training_op')) {
                    link = 'view';
                }

                // No action required.
                if (!link) return html;

                // Create button.
                var url = this.url_base + learning_unit.type + '/' + learning_unit.id + '/learner/' + this.learner.id;
                if (link == 'edit') url += '/edit';
                html += '<a href="' + url + '" class="btn btn-danger btn-sm">';
                html += lang.polaris.dashboard.sign;
                html += '</a>';
                return html;
            }

        }
    }
</script>
